import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  path = 'log/request';

  constructor() { }

  log(message: string | any): void {
      console.log(new Date().toTimeString() + ' ' + JSON.stringify(message));
  }

  debug(message: string | any): void {
    if (!environment.production){
      console.log(new Date().toTimeString() + ' ' + message);
    }
  }

  error(message: string | any, ... params: any): void {
    console.error(new Date().toTimeString() + ' ' + message, params);
  }
}
